
export const config = {
  apiKey: 'AIzaSyBkpoFkuAAT2eJVWX_rE9pLVww1ncBSUt8',
  authDomain: 'groutine-21c1b.firebaseapp.com',
  databaseURL: 'https://groutine-21c1b.firebaseio.com',
  projectId: 'groutine-21c1b',
  storageBucket: 'groutine-21c1b.appspot.com',
  messagingSenderId: '350952942983',
  appId: '1:350952942983:web:b935acc08daebd64977722',
  measurementId: '',
};

export const publicKey = 'BDcGab6fGCjY4ChyOnequzatDm6XumFhxlaXyp8GDNQV1uRyrhv-d4V8rqU54qXLNXsnFOqWLsptJko7P87NYII';
export const isDevelopment = true;
export const netlify = true;
export const graphQLUrl = 'https://aicivz8c3l.execute-api.ap-south-1.amazonaws.com/dev/graphql';
export const gauthOption = {
  clientId: '180024456007-29u01smfr15pfllbo955cabp0icelr5b.apps.googleusercontent.com',
  serverClientId: '180024456007-29u01smfr15pfllbo955cabp0icelr5b.apps.googleusercontent.com',
  androidClientId: '',
  iosClientId: '',
  scope: 'profile email',
  prompt: 'select_account',
};
